import React, { useEffect } from 'react';
import styled from 'styled-components';
import { CircleTick, Arrow } from 'assets/common_svgs';

import SimilarStockItems from './similar_stock_items';
import SimilarStockItemsCarousel from './similar_stock_items_carousel';

/**
 * Renders a <SimilarStock/> component
 * @param {Object} props
 * @param {Array} props.similarStockItems - Array items to be rendered
 * @param {Function} props.setHideSimilarStock - function to show/hide similar stock items
 * @param {Bool} props.hideSimilarStock - Bool to check if items are shown
 * @param {Bool} props.isProductDetail - Bool to check for which view the component is on
 * @param {String} props.currentStoreName - String for current location name
 * @param {String} props.tick - Image asset passed from Rails
 * @param {Object} props.price - Prices for similar stock items
 */

const SimilarStock = ({
  productId,
  handleUnit,
  similarStockItems,
  setHideSimilarStock,
  hideSimilarStock,
  isProductDetail,
  currentStoreName,
  quantity,
  tick,
  vatExclusive,
  loadingPrices,
  prices,
}) => {
  useEffect(() => {
    const products = document.querySelectorAll('.collection-product');
    products.forEach(p => {
      const lineBranch = p.getAttribute('data-branch');
      const lineProdId = p.getAttribute('data-prodid');
      if (lineBranch === currentStoreName && lineProdId === productId) {
        if (similarStockItems.length > 0) {
          p.classList.add('collection-product__with-similar-stock');
        }
      }
    });
  }, []);

  const Items = isProductDetail ? SimilarStockItemsCarousel : SimilarStockItems;
  const productDetailButtonText = hideSimilarStock
    ? 'Show similar items'
    : 'Hide similar items';

  const productListButtonText = hideSimilarStock
    ? 'View similar items in stock'
    : 'Hide similar items in stock';

  if (!similarStockItems.length) {
    return false;
  }

  return (
    <div
      className={`similar-stock__container ${
        !isProductDetail ? 'pt-8 fl fl-col fb-100 m-ai-fe' : 'pt-20'
      } `}>
      <div className={!isProductDetail ? 'fl ai-c' : 'fl ai-fs'}>
        {!isProductDetail ? (
          <CircleTick fillColorMain="#207600" fillColorSecondary="#ffffff" />
        ) : (
          <NormalTick
            src={tick}
            alt=""
            width="20px"
            height="15px"
            className="mr-05"
          />
        )}
        <div>
          {isProductDetail && (
            <p>
              Similar items are in stock at{' '}
              <strong>{currentStoreName} store</strong>
            </p>
          )}
          <HideShow
            data-testid="similarStockShowHide"
            className={`fl ai-c ${!isProductDetail ? 'ml-6' : 'm-top-1rem'}`}
            onClick={() => setHideSimilarStock(!hideSimilarStock)}>
            {!isProductDetail ? productListButtonText : productDetailButtonText}

            <Arrow fillColor="#207600" isHidden={hideSimilarStock} />
          </HideShow>
        </div>
      </div>
      {!hideSimilarStock && (
        <Items
          handleUnit={handleUnit}
          similarStockItems={similarStockItems}
          isProductDetail={isProductDetail}
          currentStoreName={currentStoreName}
          vatExclusive={vatExclusive}
          loadingPrices={loadingPrices}
          prices={prices}
          quantity={quantity}
        />
      )}
    </div>
  );
};

const NormalTick = styled.img`
  margin-top: 5px;
`;

const HideShow = styled.button`
  padding: 0;
  border: 0;
  background-color: transparent;
  width: 100%;
  color: #207600;
  text-align: left;
`;

export default SimilarStock;
